import { __awaiter, __generator } from "tslib";
import { HttpClient } from '@wix/http-client';
import { renderUtils } from '../utils/renderUtils';
import gallerySettings from '../api/gallerySettings';
import Wix from '../sdk/WixSdkWrapper';
import window from '../sdk/windowWrapper';
import { experimentsWrapper } from '../sdk/experimentsWrapper';
import AppSettings from '../api/appSettings';
import Consts from '../utils/consts';
var httpClient = new HttpClient();
var watermarkDataKey = 'watermarkData';
var WatermarkApi = /** @class */ (function () {
    function WatermarkApi(dataKey) {
        this.dataKey = dataKey;
        this.defaultWatermarkData = {
            position: 9,
            size: 40,
            opacity: 40,
            imageUrl: '8bb438_9ad16b69fd1b4ab29324f97f1323b05a~mv2.png',
            imageRatio: 1.42517815,
        };
        this.origOpacity = 40;
        this.emptyWatermarkData = {
            position: 1,
            size: 1,
            opacity: 1,
            imageUrl: '8bb438_39a78b46d4fe47069da63da9348b4ee5~mv2.png',
            imageRatio: 1,
        };
        this.cachedWatermark = {
            default: this.defaultWatermarkData,
        };
        this.disableWatermark = this.disableWatermark.bind(this);
        this.enableWatermark = this.enableWatermark.bind(this);
        try {
            this.protocol = window.location.protocol;
            this.galleryId = window.galleryId;
            this.instance = window.instance;
        }
        catch (e) {
            this.protocol = 'http:';
            this.galleryId = '';
            this.instance = '';
        }
        this.appSettings = new AppSettings();
        this.getWatermarkDataFromGallerySettingsServerAsync = this.getWatermarkDataFromGallerySettingsServerAsync.bind(this);
    }
    WatermarkApi.prototype.applyWatermarkOnMediaDialogResult = function (mediaResult, galleryId, instance) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (mediaResult && mediaResult.length) {
                var watermarSave_1 = null;
                _this.getWatermarkData(galleryId)
                    .then(function (watermarkData) {
                    var imageUrl = watermarkData.imageUrl, position = watermarkData.position, size = watermarkData.size, opacity = watermarkData.opacity;
                    watermarSave_1 = watermarkData;
                    var payload = {
                        wm: 'media/' + imageUrl,
                        wmop: opacity,
                        wmpos: position,
                        wmscl: size,
                        files: mediaResult.map(function (item) {
                            return { file_name: item.fileName };
                        }),
                    };
                    if (experimentsWrapper.getExperimentBoolean('specs.art-store.createWatermarkManifest')) {
                        return httpClient.post("".concat(_this.protocol, "//progallery.wixapps.net/editor/api/v1/watermark/gallery/").concat(galleryId, "?instance=").concat(instance, "&isStore=true"), payload, {
                            withCredentials: true,
                            xsrfCookieName: null,
                        });
                    }
                    else {
                        return;
                    }
                })
                    .then(function () {
                    resolve(watermarSave_1);
                });
            }
            else {
                reject();
            }
        });
    };
    WatermarkApi.prototype.getCompId = function () {
        return new Promise(function (resolve) {
            var compId = null;
            if (typeof window !== 'undefined' && window.isFullscreen) {
                compId = renderUtils.getWorkerWindow()['pro-gallery-fullscreen-comp-id'];
            }
            else {
                compId =
                    Wix.Utils.getOrigCompId() || Wix.Utils.getCompId() || 'default';
            }
            resolve(compId);
        });
    };
    WatermarkApi.prototype.getDataKey = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.getCompId().then(function (compId) {
                var dataKey = "".concat(_this.dataKey, "-").concat(compId);
                resolve(dataKey);
            });
        });
    };
    WatermarkApi.prototype.saveWatermark = function (_a, galleryId, instance) {
        var position = _a.position, opacity = _a.opacity, size = _a.size, imageUrl = _a.imageUrl, imageRatio = _a.imageRatio;
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.appSettings.set('watermark', {
                                position: position,
                                opacity: opacity,
                                size: size,
                                imageUrl: imageUrl,
                                imageRatio: imageRatio,
                            })];
                    case 2:
                        _b.sent();
                        // saving to the old server as well, delete when 'specs.pro-gallery.appSettings' wins
                        return [4 /*yield*/, gallerySettings.set('watermark', {
                                position: position,
                                opacity: opacity,
                                size: size,
                                imageUrl: imageUrl,
                                imageRatio: imageRatio,
                            })];
                    case 3:
                        // saving to the old server as well, delete when 'specs.pro-gallery.appSettings' wins
                        _b.sent();
                        return [2 /*return*/, this._updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance)];
                    case 4:
                        error_1 = _b.sent();
                        console.error('Failed to set watermark in appSettings: ' + error_1);
                        return [3 /*break*/, 5];
                    case 5: 
                    // saving to the old server as well, delete when 'specs.pro-gallery.appSettings' wins
                    return [2 /*return*/, this.saveWatermarkToGallerySettings({ position: position, opacity: opacity, size: size, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance)];
                }
            });
        });
    };
    WatermarkApi.prototype.saveWatermarkToGallerySettings = function (_a, galleryId, instance) {
        var _this = this;
        var position = _a.position, opacity = _a.opacity, size = _a.size, imageUrl = _a.imageUrl, imageRatio = _a.imageRatio;
        return gallerySettings
            .set('watermark', { position: position, opacity: opacity, size: size, imageUrl: imageUrl, imageRatio: imageRatio })
            .then(function () {
            return _this._updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance);
        });
    };
    WatermarkApi.prototype.getCachedWatermark = function (compId) {
        return this.cachedWatermark[compId] || this.defaultWatermarkData;
    };
    WatermarkApi.prototype.disableWatermark = function (galleryId, instance) {
        var _this = this;
        if (renderUtils.isDev()) {
            console.log('Disabling watermark');
        }
        this.getCompId().then(function (compId) {
            var opacity = _this.getCachedWatermark(compId).opacity;
            var _a = _this.getCachedWatermark(compId), position = _a.position, size = _a.size, imageUrl = _a.imageUrl, imageRatio = _a.imageRatio;
            _this.origOpacity = opacity; // save original opacity of the watermark
            opacity = 0;
            return _this.saveWatermark({ position: position, size: size, opacity: opacity, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance);
        });
    };
    WatermarkApi.prototype.enableWatermark = function (galleryId, instance) {
        var _this = this;
        if (renderUtils.isDev()) {
            console.log('Enabling watermark');
        }
        this.getCompId().then(function (compId) {
            var _a = _this.getCachedWatermark(compId), position = _a.position, size = _a.size, imageUrl = _a.imageUrl, imageRatio = _a.imageRatio;
            var opacity = _this.origOpacity; // retrieve original opacity of the watermark
            return _this.saveWatermark({ position: position, size: size, opacity: opacity, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance);
        });
    };
    WatermarkApi.prototype._updateMediaWatermark = function (imageUrl, opacity, position, size, galleryId, instance) {
        var _this = this;
        return new Promise(function (resolve) {
            if (experimentsWrapper.getExperimentBoolean('specs.art-store.createWatermarkManifest')) {
                var payload = {
                    wm: 'media/' + imageUrl,
                    wmop: opacity,
                    wmpos: position,
                    wmscl: size,
                };
                return httpClient
                    .post("".concat(_this.protocol, "//progallery.wixapps.net/editor/api/v1/watermark/gallery/").concat(galleryId, "?instance=").concat(instance, "&isStore=true"), payload, {
                    withCredentials: true,
                    xsrfCookieName: null,
                })
                    .then(function () {
                    resolve();
                });
            }
            else {
                resolve();
            }
        });
    };
    WatermarkApi.prototype.getWatermarkDataFromGallerySettingsSync = function (prerenderedGallery) {
        var watermarkData = null;
        if (prerenderedGallery && prerenderedGallery.gallerySettings) {
            var objGallerySettings = null;
            if (typeof prerenderedGallery.gallerySettings === 'string') {
                try {
                    objGallerySettings = JSON.parse(renderUtils.stripSlashes(prerenderedGallery.gallerySettings));
                }
                catch (error) { }
            }
            else if (typeof prerenderedGallery.gallerySettings === 'object') {
                objGallerySettings = prerenderedGallery.gallerySettings;
            }
            if (objGallerySettings) {
                watermarkData = objGallerySettings.watermark;
                if (watermarkData) {
                    if (typeof watermarkData === 'string') {
                        try {
                            watermarkData = JSON.parse(watermarkData);
                        }
                        catch (error) {
                            console.error("watermarkApi - watermark from gallery settings (".concat(watermarkData, ") is invalid"), error);
                        }
                    }
                }
            }
        }
        return watermarkData;
    };
    WatermarkApi.prototype.getWatermarkDataFromServerAsync = function (galleryId) {
        return __awaiter(this, void 0, void 0, function () {
            var watermark, position, opacity, size, imageUrl, imageRatio, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) return [3 /*break*/, 9];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        return [4 /*yield*/, this.appSettings.get(Consts.dataSavedState.SAVED, 'watermark')];
                    case 2:
                        watermark = _a.sent();
                        if (!(watermark !== undefined)) return [3 /*break*/, 3];
                        return [2 /*return*/, Promise.resolve(watermark)];
                    case 3: return [4 /*yield*/, this.getWatermarkDataFromGallerySettingsServerAsync(galleryId)];
                    case 4:
                        // try get watermark from old app-settings
                        watermark = _a.sent();
                        if (!watermark) return [3 /*break*/, 6];
                        position = watermark.position, opacity = watermark.opacity, size = watermark.size, imageUrl = watermark.imageUrl, imageRatio = watermark.imageRatio;
                        return [4 /*yield*/, this.appSettings.set('watermark', {
                                position: position,
                                opacity: opacity,
                                size: size,
                                imageUrl: imageUrl,
                                imageRatio: imageRatio,
                            })];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve(watermark)];
                    case 6: return [2 /*return*/, Promise.reject("watermarkApi - getWatermarkDataFromServerAsync - returned data from server is corrupt")];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_2 = _a.sent();
                        console.error('Failed to get watermark from app settings: ' + error_2);
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/, this.getWatermarkDataFromGallerySettingsServerAsync(galleryId)];
                }
            });
        });
    };
    WatermarkApi.prototype.getWatermarkDataFromGallerySettingsServerAsync = function (galleryId) {
        var _this = this;
        galleryId = galleryId || this.galleryId;
        var instance = this.instance;
        return new Promise(function (resolve, reject) {
            if (instance && galleryId) {
                httpClient
                    .get("".concat(_this.protocol, "//progallery.wixapps.net/_api/pro-gallery-editor-webapp/v1/gallery/").concat(galleryId, "?instance=").concat(instance, "&isStore=true"), {
                    withCredentials: true,
                    xsrfCookieName: null,
                })
                    .then(function (response) {
                    var data = response.data;
                    if (data &&
                        typeof data === 'object' &&
                        data.settings &&
                        data.settings.watermark) {
                        if (experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                            try {
                                _this.appSettings.set('watermark', data.settings.watermark);
                            }
                            catch (error) {
                                console.error('Failed to set watermark in app settings: ' + error);
                            }
                        }
                        resolve(data.settings.watermark);
                    }
                    else {
                        reject("watermarkApi - getWatermarkDataFromServerAsync - returned data from server is corrupt");
                    }
                })
                    .catch(function () {
                    reject("watermarkApi - getWatermarkDataFromServerAsync - request error");
                });
            }
            else {
                reject("watermarkApi - getWatermarkDataFromServerAsync - no galleryId (".concat(galleryId, ") or instance (").concat(instance, ")"));
            }
        });
    };
    WatermarkApi.prototype.getWatermarkData = function (galleryId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getCompId().then(function (compId) {
                if (_this.cachedWatermark[compId] && !renderUtils.isEditor()) {
                    // if (renderUtils.isDev()) console.log('Getting cached watermark');
                    resolve(_this.cachedWatermark[compId]);
                }
                else {
                    var prerenderedItems = void 0;
                    try {
                        prerenderedItems =
                            window.prerenderedGallery || window.prerenderedItem;
                    }
                    catch (e) {
                        prerenderedItems = [];
                    }
                    _this.cachedWatermark[compId] = _this.getWatermarkDataFromGallerySettingsSync(prerenderedItems);
                    // this.cachedWatermark = this.defaultWatermarkData; //set the default watermark until the Promise will resolve
                    renderUtils.isDev() && console.log('Getting public watermark');
                    if (_this.cachedWatermark[compId]) {
                        resolve(_this.cachedWatermark[compId]);
                    }
                    else {
                        // fall back to data.public
                        _this.getWatermarkDataFromServerAsync(galleryId)
                            .then(function (watermarkData) {
                            _this.cachedWatermark[compId] = watermarkData;
                            resolve(_this.cachedWatermark[compId]);
                        })
                            .catch(function (e) {
                            renderUtils.isDev() &&
                                console.log('Getting watermark from server failed - ', e);
                            _this.cachedWatermark[compId] = new Promise(function () {
                                _this.getDataKey().then(function (dataKey) {
                                    if (Wix && Wix.Data && Wix.Data.Public) {
                                        Wix.Data.Public.get(dataKey, { scope: Wix.Data.SCOPE.APP }, function (data) {
                                            if (renderUtils.isDev()) {
                                                console.log('Got watermark from Data.Public', data);
                                            }
                                            var parsedData = JSON.parse(data[dataKey]);
                                            _this.cachedWatermark[compId] = parsedData;
                                            resolve(parsedData);
                                        }, function (exception) {
                                            if (renderUtils.isDev()) {
                                                console.log('cannot fetch watermark from Data.Public', exception);
                                            }
                                            _this.cachedWatermark[compId] = _this.defaultWatermarkData;
                                            resolve(_this.cachedWatermark[compId]);
                                        });
                                    }
                                    else {
                                        if (renderUtils.isDev()) {
                                            console.log('Cannot get watermark from Data.Public (wix not found)');
                                        }
                                        reject('Wix not found');
                                    }
                                });
                            });
                        });
                    }
                }
            });
        });
    };
    return WatermarkApi;
}());
export default new WatermarkApi(watermarkDataKey);
//# sourceMappingURL=watermarkApi.js.map